import {
  getByUrl,
  getBySystem,
  getFromComplexExtension,
  getFromExtension
} from "@/utils/fhir-utils";
import md5 from "md5";
import { mapAnnotationStatus, mapSlideStatus } from "@/utils/deeppath-utils";

const DeepPath = {
  install(Vue, args = {}) {
    Vue.prototype.$dp = {};
    Vue.prototype.$dp.getFromExtension = (resource, extension, key) =>
      getFromExtension(resource, extension, key);

    Vue.prototype.$dp.getFromComplexExtension = (resource, extension) =>
      getFromComplexExtension(resource, extension);

    Vue.prototype.$dp.getBySystem = (array, system) =>
      getBySystem(array, system);

    Vue.prototype.$dp.getByUrl = (array, url) => getByUrl(array, url);

    Vue.prototype.$dp.mapSlideStatus = status => mapSlideStatus(status);
    Vue.prototype.$dp.mapAnnotationStatus = status =>
      mapAnnotationStatus(status);

    Vue.prototype.$dp.store = (key, data, storeHash) => {
      if (localStorage) {
        const payload = JSON.stringify(data);
        localStorage.setItem(key, payload);
        if (storeHash) {
          const hash = md5(data);
          localStorage.setItem(key + "__hash", hash);
        }
      }
    };

    Vue.prototype.$dp.read = (key, comparable) => {
      if (localStorage) {
        let fromLC = localStorage.getItem(key);
        if (fromLC !== undefined && fromLC !== "null") {
          fromLC = JSON.parse(fromLC);
        } else {
          return comparable;
        }
        // compare hashes. if hash of comparable is different, the code was updated
        // and therefore do not load from localStorage
        if (comparable) {
          let hashLC = localStorage.getItem(key + "__hash");
          if (hashLC) {
            const hash = md5(comparable);
            if (hashLC === hash) {
              return fromLC;
            } else {
              return comparable;
            }
          }
          return comparable;
        }
        return fromLC;
      }
      return comparable;
    };
  }
};

export default DeepPath;
